export class SelectListItem {
    desc: string;
    code: string;
}
